var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"invalid-feedback":_vm.errorTxt,"state":_vm.state,"disabled":_vm.disabled}},[_c('b-form-checkbox',{model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}},[_vm._v("\r\n            "+_vm._s(_vm.chkLabel)+"\r\n        ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }